<!-- Responsibility: Implement world source surface behavior for the ui/components/wizard surface.
Scope: Owns ui/components/wizard concerns only; cross-surface orchestration is excluded. -->
<world-source-surface>
  <div class="wizard-group">
    <header class="wizard-header">
      <div class="wizard-intro">
        <span class="kicker">WORLD SOURCE</span>
        <strong>{ sourceTitle() }</strong>
        <p>{ sourceSummary() }</p>
      </div>
      <div class="wizard-actions">
        <button
          type="button"
          class="action-btn { !props.view?.importedSeed ? 'primary' : '' } compact"
          disabled={ props.view?.selectingWorldId || props.view?.forging }
          onclick={ onChooseFreshWorld }
        >FORGE NEW WORLD</button>
      </div>
    </header>

    <div if={ props.view?.loading } class="note">Scanning saved realities...</div>
    <div if={ props.view?.error } class="note error">{ props.view?.error }</div>

    <div if={ props.view?.cards?.length } class="world-gallery-list">
      <button
        each={ world in props.view?.cards }
        type="button"
        data-save-id={ world.saveId }
        class="gallery-item { props.view?.selectedWorldSaveId === world.saveId ? 'selected' : '' }"
        disabled={ props.view?.selectingWorldId || props.view?.forging }
        onclick={ props.actions?.chooseWorldFromGallery }
      >
        <header>
          <b>{ world.seedLabel }</b>
          <span if={ props.view?.selectingWorldId === world.saveId } class="loading-spin">⚙</span>
        </header>
        <span class="meta">{ world.roomName } · { world.timestampLabel }</span>
      </button>
    </div>

    <div if={ !props.view?.importedSeed } class="group">
      <div>
        <label class="label">Inspiration</label>
        <textarea name="world.inspiration" placeholder="Core influences, worlds to blend..." required value={ props.draft?.world?.inspiration || '' }></textarea>
      </div>

      <div>
        <label class="label">Modifiers / Tone</label>
        <textarea name="world.modifiers" placeholder="Mood, weird constraints, tone bends..." value={ props.draft?.world?.modifiers || '' }></textarea>
      </div>

      <div>
        <label class="label">Narrative Type</label>
        <input name="world.narrativeType" type="text" placeholder="Quest shape (e.g. Political intrigue, Rescue)" value={ props.draft?.world?.narrativeType || '' }>
      </div>
    </div>

    <div if={ props.view?.importedSeed } class="group note-box">
      <span class="label">Imported Reality</span>
      <p>{ props.view?.summary }</p>
    </div>
  </div>

  <script>
    export default {
      sourceTitle() {
        return this.props.view?.importedSeed ? 'Using a saved world' : 'Forging a fresh world'
      },

      sourceSummary() {
        return this.props.view?.importedSeed
          ? 'An existing world artifact is selected.'
          : 'Choose a saved world or define a new one.'
      },

      onChooseFreshWorld(e) {
        e?.stopPropagation?.()
        this.props.actions?.chooseFreshWorld?.()
      },
    }
  </script>

  <style>
    .wizard-group {
      display: grid;
      gap: var(--space-md);
      animation: wizard-fade-in 0.3s ease-out;
    }

    .wizard-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: var(--space-md);
    }

    .wizard-intro {
      display: grid;
      gap: 0.2rem;
    }

    .kicker {
      font-size: var(--type-3xs);
      letter-spacing: 0.15em;
      color: var(--gold);
      font-weight: 800;
    }

    .wizard-intro strong {
      font-size: var(--type-md);
      color: var(--text-prose);
    }

    .wizard-intro p {
      font-size: var(--type-xs);
      color: var(--text-muted);
      margin: 0;
    }

    .world-gallery-list {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(14rem, 1fr));
      gap: var(--space-xs);
      max-height: 12rem;
      overflow-y: auto;
      padding: 0.2rem;
    }

    .gallery-item {
      text-align: left;
      background: var(--surface-card-1);
      border: 1px solid var(--border);
      border-radius: 0.5rem;
      padding: var(--space-sm);
      display: grid;
      gap: 0.25rem;
      cursor: pointer;
      transition: all 0.2s;
      
      b { font-size: var(--type-xs); color: var(--text-prose); }
      .meta { font-size: var(--type-3xs); color: var(--text-dim); }
      
      &:hover { border-color: var(--gold); background: var(--surface-card-2); }
      &.selected { border-color: var(--gold); background: color-mix(in srgb, var(--gold) 10%, var(--surface-card-1)); }
    }

    .note { font-size: var(--type-xs); color: var(--text-muted); }
    .note.error { color: var(--danger); }

    .note-box {
      padding: var(--space-md);
      background: color-mix(in srgb, var(--brand-primary) 5%, var(--surface-card-1));
      border-left: 0.25rem solid var(--brand-primary);
    }

    .loading-spin { display: inline-block; animation: spin 2s linear infinite; color: var(--gold); }



    @media (max-width: 45rem) {
      .wizard-header { flex-direction: column; }
      .wizard-actions { width: 100%; }
    }
  </style>
</world-source-surface>
